export default {
    URL_EDESIGN_PORTAL: "https://edesign.maccaferri.com/HomeHub"
}